import { Reducer } from 'react';
import { ApiError, ApiStatus } from '../api/api';
import { ConnectorReferralData, EntrepreneurProfileBody } from '../types/types';

export interface EntrepreneurReducerState {
  // values
  profile?: EntrepreneurProfileBody
  connectorReferralData?: ConnectorReferralData
  // errors
  getProfileApiError?: ApiError
  // api status
  getProfileApiStatus?: ApiStatus
}

export interface EntrepreneurReducerAction {
  type: EntrepreneurActionType
  payload?: any
}

export enum EntrepreneurActionType {
  GetProfile,
  GetProfileSuccess,
  GetProfileFailed,
  ClearError
}

export const entrepreneurReducer: Reducer<EntrepreneurReducerState, EntrepreneurReducerAction> = (state, action) => {
  switch (action.type) {
    case EntrepreneurActionType.GetProfile:
      return {
        ...state,
        getProfileApiError: undefined,
        getProfileApiStatus: ApiStatus.loading
      };
    case EntrepreneurActionType.GetProfileSuccess:
      return {
        ...state,
        profile: action.payload.profile,
        connectorReferralData: action.payload.referral,
        getProfileApiError: undefined,
        getProfileApiStatus: ApiStatus.success
      };
    case EntrepreneurActionType.GetProfileFailed:
      return {
        ...state,
        getProfileApiError: action.payload,
        getProfileApiStatus: ApiStatus.failed
      };
    case EntrepreneurActionType.ClearError:
      return {
        ...state,
        getProfileApiError: undefined
      };
    default: return state;
  }
};

export const initialState: EntrepreneurReducerState = {
  profile: undefined
};
